import { useEffect } from 'react';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import { useConfigContext } from './ConfigContext';

export default function PostHogProviderWrapper({ children }) {
  const { postHogKey, postHogHost } = useConfigContext();

  useEffect(() => {
    posthog.init(postHogKey, {
      api_host: postHogHost,
      person_profiles: 'identified_only',
    });
  }, [postHogKey, postHogHost]);

  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
}
